import Table from "@amzn/awsui-components-react/polaris/table";
import Button from "@amzn/awsui-components-react/polaris/button";
import { RecentOrder, RecentOrders } from "../../Types/RecentOrders";
import { createTimestampFromEpochSeconds } from "../../utils/formatUtils";
import { linkPhoneTool } from "../../utils/linkUtils";

interface RecentOrdersTableProps {
  recentOrders: RecentOrders;
  usePayloadCallback: (order: RecentOrder) => void;
}

const RecentOrdersTable = ({ recentOrders, usePayloadCallback }: RecentOrdersTableProps) => {
  return (
    <Table
      columnDefinitions={[
        {
          id: "timestamp",
          header: "Timestamp",
          cell: (item: RecentOrder) => createTimestampFromEpochSeconds(item.timestamp),
        },
        {
          id: "marketplace",
          header: "Marketplace",
          cell: (item: RecentOrder) => item.marketplace,
        },
        {
          id: "orderId",
          header: "Order ID",
          cell: (item: RecentOrder) => item.output.orderId,
        },
        {
          id: "createdBy",
          header: "Created By",
          cell: (item: RecentOrder) => linkPhoneTool(item.createdBy),
        },
        {
          id: "action",
          header: "Action",
          cell: (item: RecentOrder) => (
            <Button variant="normal" onClick={() => usePayloadCallback(item)}>
              Use payload
            </Button>
          ),
        },
      ]}
      items={recentOrders}
      variant="embedded"
    />
  );
};

export default RecentOrdersTable;
